import { ReducerStateType } from '@modules/users/user-listing/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
  offset: 0,
  limit: 25,
  search: '',
  order: 'desc',
  sortBy: 'profilingStatusLastUpdated',
  clearPage: true,
  totalCount: 0
} as ReducerStateType;

export const screeningListSlice = createSlice({
  name: 'screeningListing',
  initialState,
  reducers: {
    resetScreeningListingValues: state => ({
      ...state,
      offset: 0,
      limit: 25,
      search: '',
      order: 'desc',
      sortBy: 'profilingStatusLastUpdated',
      totalCount: 0
    }),
    updateScreeningListingValues: (state, { payload }) => ({
      ...state,
      ...payload
    }),
    updateScreeningListingClearPage: (
      state,
      { payload }: PayloadAction<boolean>
    ) => ({
      ...state,
      clearPage: payload
    })
  }
});

export const {
  resetScreeningListingValues,
  updateScreeningListingValues,
  updateScreeningListingClearPage
} = screeningListSlice.actions;

export default screeningListSlice.reducer;
